import { App } from '@config/site/app'
import { IntegratedApp } from '@config/site/app/integratedApps'

export const IntegratedApps: Partial<Record<App, IntegratedApp[]>> = {
  [App.STAR]: [IntegratedApp.Activations],
  [App.MUSIC]: [],
}
